<div class="row">
  <div class="col-6 d-flex justify-content-center align-items-center">
    <div>
      <sb-sankey-chart #sankey [chartData]="sankeyData"></sb-sankey-chart>
    </div>
  </div>
  <div class="col-6 d-flex justify-content-center align-items-center">
    <form [formGroup]="screenForm">
      <ng-container formArrayName="screens">
        <div class="row d-flex" *ngFor="let screen of screens().controls; let i=index"
             [formGroupName]="i">
          <div class="col-4" style="display: none;">
            <!--    <label>From</label>
                <select name="" id="" class="form-control" formControlName="tracker"></select>-->
            <label class="form-label">{{'lang.trackerAssignment.fromScreen'|translate}}</label>
            <input type="text" formControlName="screen"/>
          </div>
          <div class="col-6">
            <label class="form-label">{{'lang.trackerAssignment.connectTracker'|translate}}</label>
            <select name="" id="" class="form-select" formControlName="tracker" (ngModelChange)="updateValue(i)">
              <option value="" disabled>{{'lang.trackerAssignment.chooseTracker'|translate}}</option>
              <option *ngFor="let tracker of selectedData.tracker" [hidden]="isDisplayed(tracker)"
                      [ngValue]="tracker">{{tracker.id}}: {{tracker.name}}</option>
              <!--<option *ngFor="let tracker of getTrackerDropdown(i)" [ngValue]="tracker">{{tracker.id}}</option>-->
            </select>
          </div>
          <div class="col-4">
            <label class="form-label">{{'lang.globals.value'|translate}}</label>
            <input type="text" class="form-control" formControlName="value" (ngModelChange)="updateValue(i)"/>
          </div>
          <div class="col-2 d-flex align-items-end">
            <button (click)="deleteRow(i)" class="btn btn-danger">
              <sb-icon icon="trash"></sb-icon>
            </button>
          </div>
        </div>
      </ng-container>
      <button *ngIf="screens().controls.length < selectedData.tracker.length" type="button" class="btn btn-primary mt-2"
              (click)="addAssignmentByButton()">
        <sb-icon [icon]="'plus'" class="mr-1"></sb-icon>
        {{'lang.globals.add' | translate}}
      </button>
    </form>
  </div>
</div>
<div class="d-flex justify-content-end">
  <button class="btn btn-default" (click)="cancel()">{{'lang.globals.cancel' | translate}}</button>
  <button class="btn btn-primary ml-2" (click)="save()">{{'lang.globals.save' | translate}}</button>
</div>

